import { useState, useEffect, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useExpenseCategories() {
  const [categories, setCategories] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const fetchCategories = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/financial/expenses/categories', {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setCategories(returnFromApi.data))
      .catch((err) => console.error('Error to find categories', err))
      .finally(() => setLoading(false));
  }, []);

  const saveCategory = useCallback(
    (category) =>
      quarkusApi.post('/financial/expenses/categories', category, {
        headers: { Authorization: sessionStorage.getItem('token') },
      }),
    [],
  );

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, isLoading, refetch: fetchCategories, saveCategory };
}
